module.exports = "<div ng-form=\"form\">\n  <div class=\"{{$root.styles.fields.phone}}\"\n    ng-class=\"{error: form.{{id}}.$invalid, success: form.{{id}}.$valid && myPhone}\">\n    <input type=\"tel\"\n      name=\"{{id}}\"\n      ng-model=\"myPhone\"\n      ng-intl-tel-input\n      data-initial-country=\"fr\" />\n  </div>\n\n  <div ng-hide=\"form.{{id}}.$pristine\"\n    class=\"{{$root.styles.messages.error}}\">\n    <span ng-show=\"form.{{id}}.$invalid\"\n      ng-bind-html=\"$root.logs.phone.invalid\">\n    </span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/entities/owners/phone/directives/myPhone.html
// module id = 879
// module chunks = 0